import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { Button } from "@hopper-ui/components";
import { IconArrowUp } from "@intentui/icons";

interface Props {
    isDisabled: boolean;
}

export const ConversationSubmitButton = ({ isDisabled }: Props) => {
    const { tShared } = useSharedTranslation();

    return (
        <Button type="submit" variant="primary" size="sm" borderRadius="circle" aria-label={tShared("submit")} isDisabled={isDisabled}>
            <IconArrowUp />
        </Button>
    );
};
